import React, { useState } from 'react';
import Colors from 'enums/Colors';
import Img from '../assets/img1.jpg';
import ImgCirculo from '../assets/circulo3.svg';
import { FaRegClock } from 'react-icons/fa';
import StyledGlobal from '../Alfabetizacao360NewDetail.styled';
import { RiShareBoxLine } from 'react-icons/ri';
import ReguaLogo from '../assets/regua_nova.png';

import Styled from './styles/SecoundSession.styled';
import { IsCustomMaxWidth } from 'core/util/WindowSize';
import { TrilhaApronfundadaInfoCard } from 'pages/intermediarias/alfabetizacao360Detail/subcomponents/TrilhaApronfundadaInfoCard';
import { MdOutlineAddBox } from 'react-icons/md';
import { Modal } from 'react-bootstrap';
import { ButtonHomeV2 } from 'pages/home/components/homeV2/button/ButtonHomeV2.styled';
import { useHistory } from 'react-router-dom';
import { bucketS3, caminhoAnexosGeneralFiles } from 'constants/EnvironmentData';

//URLS DAS ATIVIDADES NA S3:
//desenvolvimento_da_linguagem_matematica
const Arquivo_DLM = 'anexo_storage_files_3861433628061717164.pdf_2025-09-08-1757357218586.pdf';
//Consciência fonológica
const Arquivo_Consciencia_Fonologica = 'anexo_storage_files_523822244610278086.pdf_2025-09-08-1757357520319.pdf';
//Dificuldades de aprendizagem e práticas de superação
const Arquivo_AMS = 'anexo_storage_files_17792162942768376549.pdf_2025-06-02-1748877472227.pdf';
//Avaliação e Monitoramento
const Arquivo_AEM = 'anexo_storage_files_7152704038351422995.pdf_2025-06-02-1748877512446.pdf';
//Cultura Digital
const Arquivo_CD = 'anexo_storage_files_10648075083645960461.pdf_2025-06-02-1748877558468.pdf';
//A educação infantil e sua conexão com a alfabetização
const Arquivo_ADICA = 'anexo_storage_files_12223832868603540813.pdf_2025-06-02-1748877581287.pdf';

//Icon
const IconYellow = 'anexo_storage_files_13441968907160207302.svg_2025-06-02-1748878472201.svg';

const SecoundSession = () => {
    const history = useHistory();
    const [show, setShow] = useState<boolean>(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const [indexAbaActive, setIndexAbA] = useState<number>(1);

    const [indexModuleActive, setIndexModuleActive] = useState<number>(-1);
    const [indexModuleActiveModal, setIndexModuleModalActive] = useState<number>(-1);

    const isMax500 = IsCustomMaxWidth(500);
    const isMax1210 = IsCustomMaxWidth(1210);

    const goToCourse = () => {
        history.push('/recursos/trilhas/trilha-de-alfabetizacao-aprofundada?redirect=/alfabetizacao-360');
    };

    const getURLS3 = () => {
        return bucketS3() + caminhoAnexosGeneralFiles();
    };

    function sanitizeFileName(fileName: string): string {
        // Aqui, você pode adicionar uma lógica para remover caracteres não permitidos
        return fileName.replace(/[^\w\s\.\-]/gi, '');
    }
    const mimeToExtension = (mime: string): string => {
        const mimeTypes: { [key: string]: string } = {
            'application/pdf': '.pdf',
            'application/vnd.ms-powerpoint': '.ppt',
            'application/vnd.openxmlformats-officedocument.presentationml.presentation': '.pptx',
            'application/msword': '.doc',
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document': '.docx',
            'image/jpeg': '.jpg',
            'image/png': '.png',
            'image/gif': '.gif',
            'text/plain': '.txt',
            'application/zip': '.zip',
            'application/x-rar-compressed': '.rar',
            'application/json': '.json',
            // Adicione outros tipos conforme necessário
        };

        return mimeTypes[mime] || ''; // Retorna uma string vazia caso o tipo não tenha correspondência
    };

    const handleDownload = async (fileUrl: string, fileName: string) => {
        const fileByBucket = getURLS3() + fileUrl;

        const response = await fetch(fileByBucket);
        if (!response.ok) throw new Error('Network response was not ok');

        const blob = await response.blob();

        const fileExtension = mimeToExtension(blob.type); // Obter a extensão do arquivo com base no tipo MIME
        const sanitizedFileName = sanitizeFileName(fileName) + (fileExtension || '.pptx');

        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = sanitizedFileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(link.href);
    };

    return (
        <Styled.Container>
            <Modal centered scrollable show={show} onHide={handleClose} backdrop="static" keyboard={false} size="lg">
                <Modal.Body style={{ height: '320px', gap: '2rem', display: 'flex', flexDirection: 'column', padding: '32px' }}>
                    {TrilhaApronfundadaInfoCard.sort((a, b) => a.ordem - b.ordem).map((card, index) => (
                        <div key={index} style={{ display: 'flex', flexDirection: 'column', borderBottom: '1px solid #6c6c6c' }}>
                            <Styled.Module.Info style={{ gap: '1rem', paddingBottom: '22px' }}>
                                <Styled.Module.Row>
                                    <h1>{card.title}</h1>

                                    <MdOutlineAddBox
                                        size={32}
                                        cursor={'pointer'}
                                        onClick={() => setIndexModuleModalActive(index)}
                                        color={Colors.Blue}
                                    />
                                </Styled.Module.Row>

                                {indexModuleActiveModal === index && (
                                    <>
                                        <p>{card.description}</p>
                                        <Styled.Row>
                                            <FaRegClock color={Colors.SoftBlue} />
                                            {card.time}
                                        </Styled.Row>
                                    </>
                                )}
                            </Styled.Module.Info>
                        </div>
                    ))}
                </Modal.Body>
                <Modal.Footer
                    style={{
                        display: 'flex',
                        alignContent: 'center',
                        justifyContent: 'center',
                        flexDirection: isMax500 ? 'column-reverse' : 'row',
                    }}
                >
                    <ButtonHomeV2 style={{ width: isMax500 ? '250px' : '167px' }} onClick={handleClose}>
                        Fechar
                    </ButtonHomeV2>
                    <StyledGlobal.ButtonYellow onClick={goToCourse}>
                        Acessar <RiShareBoxLine />
                    </StyledGlobal.ButtonYellow>
                </Modal.Footer>
            </Modal>
            <Styled.Content>
                <Styled.TagBlue>Certificado pelo IEA USP Ribeirão Preto e Instituto Ayrton Senna</Styled.TagBlue>
                <Styled.ContentAbas>
                    <Styled.Aba active={indexAbaActive === 1} onClick={() => setIndexAbA(1)}>
                        Sobre o Curso
                    </Styled.Aba>
                    <Styled.Aba active={indexAbaActive === 2} onClick={() => setIndexAbA(2)}>
                        Módulos do Curso
                    </Styled.Aba>
                    <Styled.Aba active={indexAbaActive === 3} onClick={() => setIndexAbA(3)}>
                        Atividades Práticas
                    </Styled.Aba>
                </Styled.ContentAbas>

                {indexAbaActive === 1 ? (
                    <>
                        <Styled.Body>
                            <Styled.Column>
                                <Styled.Paragrafo
                                    dangerouslySetInnerHTML={{
                                        __html: `
                                *Ministério da Cultura, Alura Start e Guaraná Antarctica apresentam: ALFABETIZAÇÃO INTEGRAL EM APOIO AO COMPROMISSO NACIONAL CRIANÇA ALFABETIZADA
                            
                            `,
                                    }}
                                />
                                <Styled.Title style={{ maxWidth: '500px', fontSize: "28px" }}>ALFABETIZAÇÃO INTEGRAL EM APOIO AO COMPROMISSO NACIONAL CRIANÇA ALFABETIZADA</Styled.Title>
                                <Styled.Row style={{ gap: '28px' }}>
                                    <Styled.Row>
                                        <FaRegClock color={Colors.Yellow} />
                                        Gratuito
                                    </Styled.Row>
                                    <Styled.Row>
                                        <FaRegClock color={Colors.SoftBlue} />
                                        22h
                                    </Styled.Row>
                                </Styled.Row>

                                <Styled.Paragrafo
                                    fontSize={isMax500 ? '14px' : '16px'}
                                    dangerouslySetInnerHTML={{
                                        __html: `
                               Mergulhe em mais essa trilha de alfabetização e <strong>explore diferentes temas relacionados à temática e promoção da mesma</strong>, como letramentos e multiletramentos, avaliação e monitoramento, cultura digital na alfabetização, entre outros.
                            
                            `,
                                    }}
                                />
                                <StyledGlobal.ButtonYellow onClick={goToCourse}>
                                    Acessar <RiShareBoxLine />
                                </StyledGlobal.ButtonYellow>
                            </Styled.Column>
                            <Styled.Img src={Img} />
                        </Styled.Body>
                    </>
                ) : indexAbaActive === 2 ? (
                    <>
                        <Styled.Body>
                            <Styled.Column>
                                <Styled.Title>
                                    ALFABETIZAÇÃO INTEGRAL EM <br /> APOIO AO COMPROMISSO NACIONAL CRIANÇA ALFABETIZADA
                                </Styled.Title>
                                <Styled.Row style={{ gap: '28px' }}>
                                    <Styled.Row>
                                        <FaRegClock color={Colors.SoftBlue} />
                                        1h30
                                    </Styled.Row>
                                </Styled.Row>

                                <Styled.Paragrafo
                                    fontSize={isMax500 ? '14px' : '16px'}
                                    dangerouslySetInnerHTML={{
                                        __html: `
                              Neste módulo, falaremos sobre a história da escrita e do alfabeto, o olhar para a educação integral, os dados atuais sobre o cenário da alfabetização no Brasil e as políticas públicas já propostas e implementadas.
                            
                            `,
                                    }}
                                />
                                <Styled.RowButtons>
                                    <StyledGlobal.ButtonYellow onClick={goToCourse}>
                                        Acessar <RiShareBoxLine />
                                    </StyledGlobal.ButtonYellow>
                                    {isMax1210 && <Styled.ButtonOutline onClick={handleShow}>Mostrar mais módulos</Styled.ButtonOutline>}
                                </Styled.RowButtons>
                            </Styled.Column>
                            <Styled.Column style={{ width: '50%', display: isMax1210 ? 'none' : 'flex' }}>
                                {TrilhaApronfundadaInfoCard.sort((a, b) => a.ordem - b.ordem)
                                    .slice(0, 5)
                                    .map((card, index) => (
                                        <div key={index} style={{ display: 'flex', flexDirection: 'column', borderBottom: '1px solid #6c6c6c' }}>
                                            <Styled.Module.Info>
                                                <Styled.Module.Row>
                                                    <h1>{card.title}</h1>
                                                    <MdOutlineAddBox
                                                        size={32}
                                                        cursor={'pointer'}
                                                        onClick={() => setIndexModuleActive(index)}
                                                        color={Colors.Blue}
                                                    />
                                                </Styled.Module.Row>
                                                {indexModuleActive === index && (
                                                    <>
                                                        <p>{card.description}</p>
                                                        <Styled.Row>
                                                            <FaRegClock color={Colors.SoftBlue} />
                                                            {card.time}
                                                        </Styled.Row>
                                                    </>
                                                )}
                                            </Styled.Module.Info>
                                        </div>
                                    ))}
                                <Styled.ButtonOutline onClick={handleShow}>Mostrar mais módulos</Styled.ButtonOutline>
                            </Styled.Column>
                        </Styled.Body>
                    </>
                ) : (
                    <Styled.Body>
                        <Styled.Column>
                            <Styled.Title style={{ maxWidth: '100%' }}>Atividades práticas</Styled.Title>

                            <Styled.Paragrafo
                                style={{ maxWidth: isMax500 ? '100%' : '70%' }}
                                fontSize={isMax500 ? '14px' : '16px'}
                                dangerouslySetInnerHTML={{
                                    __html: `
                             Aqui você irá encontrar <b>atividades práticas relacionadas as aulas da Trilha Alfabetização Integral </b>em apoio ao Compromisso Nacional Criança Alfabetizada.
                            
                            `,
                                }}
                            />
                            <Styled.Actives.Container>
                                <Styled.Actives.Content
                                    onClick={() => handleDownload(Arquivo_DLM, 'o-desenvolvimento-da-linguagem-matematica.pdf')}
                                >
                                    <h1>O desenvolvimento da linguagem matemática</h1>
                                    <img src={getURLS3() + IconYellow} alt="Icone" />
                                </Styled.Actives.Content>

                                <Styled.Actives.Content
                                    onClick={() => handleDownload(Arquivo_Consciencia_Fonologica, 'consciencia_fonologica.pdf')}
                                >
                                    <h1>Consciência fonológica</h1>
                                    <img src={getURLS3() + IconYellow} alt="Icone" />
                                </Styled.Actives.Content>
                                <Styled.Actives.Content
                                    onClick={() => handleDownload(Arquivo_AMS, 'dificuldades-de-aprendizagem-e-práticas-de-superacao.pdf')}
                                >
                                    <h1>Dificuldades de aprendizagem e práticas de superação</h1>
                                    <img src={getURLS3() + IconYellow} alt="Icone" />
                                </Styled.Actives.Content>
                                <Styled.Actives.Content onClick={() => handleDownload(Arquivo_AEM, 'avaliacao_e_monitoriamento.pdf')}>
                                    <h1>Avaliação e Monitoramento</h1>
                                    <img src={getURLS3() + IconYellow} alt="Icone" />
                                </Styled.Actives.Content>
                                <Styled.Actives.Content onClick={() => handleDownload(Arquivo_CD, 'cultura_digital.pdf')}>
                                    <h1>Cultura Digital</h1>
                                    <img src={getURLS3() + IconYellow} alt="Icone" />
                                </Styled.Actives.Content>
                                <Styled.Actives.Content
                                    onClick={() => handleDownload(Arquivo_ADICA, 'a-educacao-infantil-e-sua-conexao-com-a-alfabetizacao.pdf')}
                                >
                                    <h1>A educação infantil e sua conexão com a alfabetização</h1>
                                    <img src={getURLS3() + IconYellow} alt="Icone" />
                                </Styled.Actives.Content>
                            </Styled.Actives.Container>
                        </Styled.Column>
                    </Styled.Body>
                )}
                <img style={{ width: '100%', zIndex: 20 }} src={ReguaLogo} />
            </Styled.Content>

            <Styled.ImgCircule src={ImgCirculo} />
        </Styled.Container>
    );
};

export default SecoundSession;
